import { render, staticRenderFns } from "./FormResponse.vue?vue&type=template&id=244d36be"
import script from "./FormResponse.vue?vue&type=script&lang=js"
export * from "./FormResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports